(() => {
/**
 * @fileoverview Shorts Modal
 *
 */ /**
 * Need to following functions:
 * - total number of items in the collection
 * - total number of items fully visible in the viewport
 * - calculate number of 'pages'
 * - generate links for pages
 *
 */ const $9ba6f1688692386e$var$throttle = function(func, limit) {
    let inThrottle;
    return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
};
// debounce function
function $9ba6f1688692386e$var$debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
/**
 * Normalise the scroll event across browsers
 *
 * @param {HTMLElement} element
 * @param {Function} func
 * @param  {...any} args
 */ const $9ba6f1688692386e$var$onScrollEnd = function(element, func, ...args) {
    const context = this;
    if ('onscrollend' in window) element.addEventListener('scrollend', ()=>{
        func.apply(context, args);
    });
    else // fall back to scroll listener with timeout for browsers
    // that don't support scrollend
    element.addEventListener('scroll', ()=>{
        clearTimeout(window.scrollEndTimer);
        window.scrollEndTimer = setTimeout(()=>{
            func.apply(context, args);
        }, 50);
    });
};
/**
 * Check whether an element is in the viewport based on it's position
 * relative to the parent element. We are comparing the right edge of the
 * element to the right edge of the parent element and the left edge of the
 * element to the left edge of the parent element.
 *
 * The offset is used to add a buffer to the comparison on the left edge of the
 * parent element only.
 *
 * @param {*} element - html element
 * @param {*} parent - html element
 * @param {*} offset - number
 */ const $9ba6f1688692386e$var$withinViewport = (element, parent, offset)=>{
    offset = offset || 0;
    const elementRect = element.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    return elementRect.left >= parentRect.left - offset && elementRect.right <= parentRect.right;
};
/**
 * Check whether an element is past a certain point in the viewport, we are
 * comparing the left edge of the element to the left edge of the parent
 * element.
 *
 * @param {*} element - html element
 * @param {*} parent
 * @param {*} offset
 * @returns
 */ const $9ba6f1688692386e$var$itemLeftOfParent = (element, parent, offset)=>{
    offset = offset || 0;
    const elementRect = element.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    return elementRect.left <= parentRect.left + offset;
};
/**
 * Declare our pager object
 *
 */ const $9ba6f1688692386e$var$pager = {};
/**
 * Object passed to the init function to initialise the pager object
 * includes optoins for the pager object and selectors for the pager and grid
 * and grid items.
 * @param {*} element
 */ $9ba6f1688692386e$var$pager.init = function({ element: element, gridSelector: gridSelector = '.shorts-grid', pagerSelector: pagerSelector = '.shorts-pager', pagerItemClass: pagerItemClass = 'shorts-pager-item' } = {}) {
    this.rootElement = element;
    this.grid = this.rootElement.querySelector(gridSelector);
    this.pager = this.rootElement.querySelector(pagerSelector);
    // get all children of the grid element
    this.items = this.grid.children;
    this.pagerItemClass = pagerItemClass;
    this.pagerItemSelector = `.${pagerItemClass}`;
    this.initPager();
    this.initScroll();
};
$9ba6f1688692386e$var$pager.getNumberOfItems = function() {
    return this.items.length;
};
/**
 * Calculate the number of displayed elements that should be visible in
 * the viewport at this point.
 */ $9ba6f1688692386e$var$pager.getNumberOfItemsFullyVisible = function() {
    const computedStyle = getComputedStyle(this.grid);
    const gapSize = parseInt(computedStyle.gap, 10);
    const itemWidth = this.items[0].offsetWidth + gapSize;
    const containerWidth = this.grid.offsetWidth;
    return Math.floor((containerWidth + gapSize * 2) / itemWidth);
};
$9ba6f1688692386e$var$pager.getNumberOfPages = function() {
    const totalItems = this.getNumberOfItems();
    const itemsFullyVisible = this.getNumberOfItemsFullyVisible();
    return Math.ceil(totalItems / itemsFullyVisible);
};
/**
 * This function returns a javascript array of elements which are a
 * set number of items apart based on the number of elements which are
 * currently visible in the viewport.
 *
 * TODO: clarify this section
 * The benefit of this is that the last index item might be an element which
 * will never be fully to the left in the viewport but attempting to scroll
 * to that position still works
 *
 * @return array
 */ $9ba6f1688692386e$var$pager.calculateScrollIndex = function() {
    const numberOfPages = this.getNumberOfPages();
    const scrollIndex = [];
    for(let i = 0; i < numberOfPages; i++)scrollIndex.push(i * this.getNumberOfItemsFullyVisible());
    return scrollIndex;
};
$9ba6f1688692386e$var$pager.populatePager = function() {
    this.pager.innerHTML = '';
    const pagerLinks = this.generatePagerLinks();
    // if we only have one page, don't show the pager
    if (pagerLinks.length === 1) return;
    pagerLinks.forEach((link)=>{
        this.pager.appendChild(link);
    });
};
$9ba6f1688692386e$var$pager.generatePagerLinks = function() {
    const numberOfPages = this.getNumberOfPages();
    const pagerLinks = [];
    const scrollIndex = this.calculateScrollIndex();
    for(let i = 0; i < numberOfPages; i++)pagerLinks.push(this.generatePagerLink(i, scrollIndex[i]));
    return pagerLinks;
};
$9ba6f1688692386e$var$pager.generatePagerLink = function(pageNumber, itemNumber) {
    const btn = document.createElement('button');
    btn.classList.add(this.pagerItemClass);
    btn.setAttribute('aria-label', `Page ${pageNumber + 1}`);
    btn.setAttribute('data-page', pageNumber);
    btn.setAttribute('data-item', itemNumber);
    return btn;
};
$9ba6f1688692386e$var$pager.updatePager = function() {
    const that = this;
    this.populatePager();
    // TODO: potentially refactor this out?
    // once we've populate the pager we need to add the event listeners
    const pagerItems = this.pager.querySelectorAll(this.pagerItemSelector);
    pagerItems.forEach((item)=>{
        item.addEventListener('click', function() {
            const i = item.getAttribute('data-item');
            const left = that.items[i].offsetLeft;
            const parent = that.items[i].parentElement;
            parent.scrollTo({
                left: left,
                behavior: 'smooth'
            });
        });
    });
};
$9ba6f1688692386e$var$pager.updateActivePage = function() {
    const scrollIndex = this.calculateScrollIndex();
    // if the last element is in view, set the active page to the last page
    if ($9ba6f1688692386e$var$withinViewport(this.items[this.items.length - 1], this.grid, 16)) {
        this.setActivePage(scrollIndex.length - 1);
        return;
    }
    // set active page to 0
    let activePage = 0;
    // loop through our scrollIndex and check each one to see if it is to the
    // left of the parent element (or within the buffer zone)
    for(let i = 0; i < scrollIndex.length; i++)if ($9ba6f1688692386e$var$itemLeftOfParent(this.items[scrollIndex[i]], this.grid, 16)) activePage = i;
    this.setActivePage(activePage);
};
$9ba6f1688692386e$var$pager.setActivePage = function(pageNumber) {
    const pagerItems = this.pager.querySelectorAll(this.pagerItemSelector);
    if (pagerItems.length > 0) {
        pagerItems.forEach((item)=>{
            item.classList.remove('active');
        });
        try {
            pagerItems[pageNumber].classList.add('active');
        } catch (TypeError) {
            // This is a catch all for TypeError when the pagerItems[pageNumber]
            // is undefined. This is a known issue when resizing the window
            // and the number of items in the grid changes.
            //
            // Might be worth using requestAnimationFrame to update the pager
            // so that the pager is updated after the grid has been updated.
            console.error([
                pageNumber,
                TypeError
            ]);
        }
    }
};
/**
 * Initialise the pager
 */ $9ba6f1688692386e$var$pager.initPager = function() {
    const that = this;
    // attach event listener for resize event
    window.addEventListener('resize', $9ba6f1688692386e$var$debounce(function() {
        that.updatePager();
        that.updateActivePage();
    }, 250));
    this.updatePager();
    this.updateActivePage();
    this.onScrollEnd();
};
$9ba6f1688692386e$var$pager.initScroll = function() {
    const that = this;
    const throttledScrollHandler = $9ba6f1688692386e$var$throttle(function() {
        that.updateActivePage();
    }, 50);
    this.grid.addEventListener('scroll', throttledScrollHandler);
};
$9ba6f1688692386e$var$pager.onScrollEnd = function() {
    const that = this;
    const handleScrollEnd = ()=>{
        that.updateActivePage();
    };
    $9ba6f1688692386e$var$onScrollEnd(this.grid, handleScrollEnd);
};
/**
 * Creates a pager object with the given slider.
 *
 * Pass the slider object to the pager object to create the pager.
 *
 * @param {Object} slider - The slider object to create the pager for.
 * @return {pager} - The pager object.
 */ const $9ba6f1688692386e$var$makePager = function(element) {
    const obj = Object.create($9ba6f1688692386e$var$pager);
    obj.init({
        element: element
    });
    return obj;
};
var $9ba6f1688692386e$export$2e2bcd8739ae039 = $9ba6f1688692386e$var$makePager;


/**
 * @module shortsModal
 * @param {string} videoId - Youtube Id
 * @param {string} title - Title of the video
 * @return {iframe}
 */ const $11a931bc692d4589$var$createIframe = function(videoId, title) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`);
    iframe.setAttribute('width', '418');
    iframe.setAttribute('height', '742');
    iframe.setAttribute('title', title);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
    iframe.setAttribute('allowfullscreen', '');
    return iframe;
};
const $11a931bc692d4589$var$modalTemplate = `
  <div id="shorts-modal" class="shorts-modal">
    <div class="shorts-modal-inner" role="dialog">
      <div class="shorts-modal-buttons">
        <button type="button" class="shorts-modal-button shorts-modal-button-prev">
          <svg class="shorts-modal-button-icon" width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path d="M 67 0 L 17 50 L 67 100 L 83 84 L 49 50 L 83 16 L 67 0 Z"/>
          </svg>
          <span class="shorts-modal-button-text">Previous</span>
        </button>
        <button type="button" class="shorts-modal-button shorts-modal-button-next">
          <svg class="shorts-modal-button-icon" width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path d="M 33 0 L 83 50 L 33 100 L 17 84 L 51 50 L 17 16 L 33 0 Z"/>
          </svg>
          <span class="shorts-modal-button-text">Next</span>
        </button>
      </div>
      <div class="shorts-modal-content"></div>
      <div aria-hidden="true" class="shorts-modal-indicators"></div>
      <button type="button" class="shorts-modal-button shorts-modal-button-close">
        <svg class="shorts-modal-button-icon" width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path id="Cross" d="M 84.152718 100 L 50 65.846855 L 15.846903 100 L 0 84.153145 L 34.153191 50 L 0 15.846855 L 15.846903 0 L 50 34.153145 L 84.152718 0 L 99.998489 15.846855 L 65.846901 50 L 99.998489 84.153145 Z"/>
        </svg>
        <span class="shorts-modal-button-text">Close</span>
      </button>
    </div>
  </div>`;
/**
   *
   * @return {Object} Object with open, next, previous, close, videoListSet, videoListClear, videoList methods
   */ const $11a931bc692d4589$var$shortsPlayer = function() {
    const selector = '.shorts-modal';
    document.body.insertAdjacentHTML('beforeend', $11a931bc692d4589$var$modalTemplate);
    let videos = [];
    let currentId = null;
    let activeElement = null;
    const modal = document.querySelector(selector);
    const modalContent = modal.querySelector('.shorts-modal-content');
    const modalClose = modal.querySelector('.shorts-modal-button-close');
    const modalNext = modal.querySelector('.shorts-modal-button-next');
    const modalPrev = modal.querySelector('.shorts-modal-button-prev');
    const modalActiveClass = 'shorts-modal-active';
    const indicatorActiveClass = 'indicator-active';
    const open = function(videoId) {
        activeElement = document.activeElement;
        modal.classList.add(modalActiveClass);
        setupIndicators();
        setPlayer(videoId);
        modalNext.focus();
        document.body.classList.add('shorts-modal-open');
    };
    const close = function() {
        modal.classList.remove(modalActiveClass);
        modalContent.innerHTML = '';
        document.body.classList.remove('shorts-modal-open');
        videos = [];
        if (activeElement) activeElement.focus();
    };
    const next = function() {
        const nextId = getNextId();
        if (nextId) setPlayer(nextId);
    };
    const previous = function() {
        const prevId = getPreviousId();
        if (prevId) setPlayer(prevId);
    };
    modal.addEventListener('click', (e)=>{
        if (e.target === modal) close();
    });
    modalClose.addEventListener('click', (e)=>{
        e.preventDefault();
        close();
    });
    modalNext.addEventListener('click', (e)=>{
        e.preventDefault();
        next();
    });
    modalPrev.addEventListener('click', (e)=>{
        e.preventDefault();
        previous();
    });
    modal.addEventListener('keydown', (e)=>{
        // focus trap
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === modalPrev) {
                    e.preventDefault();
                    modalClose.focus();
                }
            } else if (document.activeElement === modalClose) {
                e.preventDefault();
                modalPrev.focus();
            }
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            close();
        }
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            next();
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            previous();
        }
    });
    const getIndexOfCurrentId = function() {
        return videos.indexOf(currentId);
    };
    const getNextId = function() {
        const index = getIndexOfCurrentId();
        return videos[index + 1];
    };
    const getPreviousId = function() {
        const index = getIndexOfCurrentId();
        return videos[index - 1];
    };
    const setPlayer = function(videoId) {
        modalContent.innerHTML = '';
        modalContent.appendChild($11a931bc692d4589$var$createIframe(videoId, 'Shorts Player'));
        currentId = videoId;
        setActiveIndicator();
    };
    const setupIndicators = function() {
        const indicators = modal.querySelector('.shorts-modal-indicators');
        indicators.innerHTML = '';
        videos.forEach(()=>{
            const indicator = document.createElement('span');
            indicator.classList.add('shorts-modal-indicator');
            indicators.appendChild(indicator);
        });
    };
    const setActiveIndicator = function() {
        const index = getIndexOfCurrentId();
        const indicators = modal.querySelectorAll('.shorts-modal-indicator');
        indicators.forEach((indicator, i)=>{
            if (i === index) indicator.classList.add(indicatorActiveClass);
            else indicator.classList.remove(indicatorActiveClass);
        });
    };
    return {
        open: open,
        next: next,
        previous: previous,
        close: close,
        videoListSet: function(videoIds) {
            videos = videoIds;
        },
        videoListClear: function() {
            videos = [];
        },
        videoList: function() {
            return videos;
        }
    };
};
const $11a931bc692d4589$var$player = $11a931bc692d4589$var$shortsPlayer();
/**
   * Initialize the shorts modal with the given options
   *
   * @param {object} options Object with selector and itemDataAttribute
   * @param {string} selector Selector of the shorts container
   * @param {string} itemDataAttribute Data attribute used to provide the
   * video id, the default is 'data-ytshort-id'
   */ const $11a931bc692d4589$var$shortsModal = function({ selector: selector = '.shorts', itemDataAttribute: itemDataAttribute = 'data-ytshort-id' } = {}) {
    const shorts = document.querySelectorAll(selector);
    const attrSelector = `[${itemDataAttribute}]`;
    shorts.forEach((short)=>{
        const els = short.querySelectorAll(attrSelector);
        const videoIds = Array.from(els).map((el)=>{
            return el.getAttribute(itemDataAttribute);
        });
        short.addEventListener('click', (e)=>{
            if (!e.target.closest(attrSelector)) return;
            e.preventDefault();
            const videoId = e.target.closest(attrSelector).getAttribute(itemDataAttribute);
            $11a931bc692d4589$var$player.videoListSet(videoIds);
            $11a931bc692d4589$var$player.open(videoId);
        });
        // initialise the pager
        (0, $9ba6f1688692386e$export$2e2bcd8739ae039)(short);
    });
};
var $11a931bc692d4589$export$2e2bcd8739ae039 = $11a931bc692d4589$var$shortsModal;


window.shortsModal = (0, $11a931bc692d4589$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=index.js.map
